import React from 'react';
import { colors, radius, spacing, typography, transitions } from '../../theme';

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'progress', label: 'Progress' },
  { id: 'checkins', label: 'Check-Ins' },
  { id: 'records', label: 'Records' },
];

/**
 * Horizontally-scrollable pill tab strip — same pattern EnhancedStats.jsx
 * already used for its 3-tab strip (styles.tabs/tab/tabActive), ported onto
 * theme.js tokens and extended to 4 items. No overflow menu needed; the
 * strip already scrolls on narrow phones.
 */
const TabSwitcher = ({ activeTab, onTabChange }) => (
  <div style={styles.tabs}>
    {TABS.map((tab) => (
      <button
        key={tab.id}
        onClick={() => onTabChange(tab.id)}
        style={{
          ...styles.tab,
          ...(activeTab === tab.id ? styles.tabActive : {}),
        }}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

const styles = {
  tabs: {
    display: 'flex',
    gap: spacing.sm,
    marginBottom: spacing.xl,
    overflowX: 'auto',
    paddingBottom: spacing.sm,
  },
  tab: {
    padding: `${spacing.sm} ${spacing.lg}`,
    minHeight: '44px',
    backgroundColor: colors.surface1,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.pill,
    color: colors.textMuted,
    ...typography.caption,
    fontWeight: '600',
    cursor: 'pointer',
    transition: transitions.buttonPress,
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
  tabActive: {
    backgroundColor: colors.gold,
    borderColor: colors.gold,
    color: colors.bg,
  },
};

export default TabSwitcher;
